import React from "react";
import {
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Container,
  Grid,
} from "@mui/material";
import { Icon } from "@iconify/react";


export default function WasteCollection() {

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, sm: 3 },
              borderRadius: 4,
              borderLeft: "8px solid #163e6a",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
            >
               Nuevos Horarios y Modalidades
            </Typography>

            <Typography
              variant="body1"
              sx={{ fontSize: "1rem" }}
            >
              Con el objetivo de mejorar el servicio y seguir construyendo una
              localidad más limpia y sostenible, la Municipalidad de La Granja
              informa los nuevos horarios, modalidades y recorridos de
              recolección vigentes en todo el ejido municipal.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, sm: 3 },
              borderRadius: 4,
              borderLeft: "8px solid #163e6a",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
            >
              Recolección Domiciliaria
            </Typography>

            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 1 }}
            >
              Horario: desde las 23:00 hs
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 1 }}
            >
              Sacar los residuos a partir de las 20:00 hs.
            </Typography>

            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 1 }}
            >
              Sábados y feriados: la recolección se realiza por la mañana, a
              partir de las 6:00 hs.
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 1 }}
            >
              Evitemos sacar la basura fuera de horario para mantener el orden y
              la higiene en cada barrio.
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: "1rem" }}
            >
              Recordá que está en vigencia la Ordenanza N°801/24, que exige
              contar con un cesto de basura domiciliario. Esta medida busca
              mantener limpia la localidad y evitar la dispersión de residuos
              por animales o por el viento.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, sm: 3 },
              borderRadius: 4,
              borderLeft: "8px solid #163e6a",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
            >
              Recolección Comercial
            </Typography>

            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 1 }}
            >
              Días: de lunes a sábados
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 1 }}
            >
              Horario: desde las 17:00 hs
            </Typography>

            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 1 }}
            >
              Destinada a comercios, bares y establecimientos con actividad
              comercial. Se solicita disponer los residuos antes de ese horario.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, sm: 3 },
              borderRadius: 4,
              borderLeft: "8px solid #163e6a",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
            >
              Recolección de Verdes (poda, pasto y hojas)
            </Typography>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={12} sm={6} display="flex" flexDirection={"column"}>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontSize: { xs: "1.1rem", sm: "1.2rem" } }}
                >
                  Hojas y pasto en bolsas:
                </Typography>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:leaf" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Lunes: La Granja"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:leaf" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Martes: Villa Ani Mi"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:leaf" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Miercoles: Martin Fierro y Los Molles"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:leaf" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Jueves: Las Vertientes"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:leaf" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Viernes: Ascochinga"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                </List>
              </Grid>
              <Grid item xs={12} sm={6} display="flex" flexDirection={"column"}>
                <Typography
                  variant="h6"
                  sx={{ fontSize: { xs: "1.1rem", sm: "1.2rem" } }}
                >
                  Podas y ramas:
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: "1rem", mb: 1 }}
                >
                  Se recolectan previa solicitud al número de reclamos
                  municipal.
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: "1rem", mb: 1 }}
                >
                  El servicio se realiza con el carretón municipal, sujeto a la
                  disponibilidad y demanda de cada semana.
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: "1rem", mb: 1 }}
                >
                  Se implementa una nueva modalidad para agilizar el retiro y
                  colaborar con quienes puedan necesitar la leña: las ramas
                  deben disponerse atadas en manojos ordenados, de hasta 1 metro
                  de largo y de tamaño que pueda ser fácilmente levantado con
                  los brazos.
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: "1rem" }}
                >
                  Los manojos serán retirados con mayor rapidez, mientras que la
                  forma tradicional de disponer montículos de ramas continuará
                  vigente, pero puede presentar demoras según la demanda y
                  disponibilidad del servicio.
                </Typography>
              </Grid>
            </Grid>

            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 2 }}
            >
              Recordá no mezclar residuos verdes con otros tipos de residuos
              (plástico, cartón, metales, escombros, etc), para mantener un
              servicio más ágil y eficiente para todos
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
        <Paper
            elevation={3}
            sx={{
              p: { xs: 2, sm: 3 },
              borderRadius: 4,
              borderLeft: "8px solid #163e6a",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
            >
              Descacharreo (retiro de voluminosos)
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 2 }}
            >
              Este servicio se realiza por solicitud. Los vecinos deben enviar
              su ubicación al número de reclamos municipal, solicitando el
              retiro de objetos grandes como muebles, electrodomésticos o
              chatarra.
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 2 }}
            >
              Número de reclamos: 3525 449310
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, sm: 3 },
              borderRadius: 4,
              borderLeft: "8px solid #163e6a",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
            >
              Recorridos por Días y Sectores
            </Typography>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={12} sm={6} display="flex" flexDirection={"column"}>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontSize: { xs: "1.1rem", sm: "1.2rem" } }}
                >
                  Lunes, Miércoles y Viernes:
                </Typography>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:map-marker" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Villa Ani Mi (Barrio Colonial, Barrio La Quebrada hasta Calle El Parral)"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:map-marker" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Villa Ani Mi Este hasta Martín Fierro"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:map-marker" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Barrio El Aguaribay"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:map-marker" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="La Granja – La Granja (Sindicato del Seguro)"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:map-marker" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Resto de La Granja"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                </List>
              </Grid>
              <Grid item xs={12} sm={6} display="flex" flexDirection={"column"}>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontSize: { xs: "1.1rem", sm: "1.2rem" } }}
                >
                  Martes, Jueves y Sábados:
                </Typography>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:map-marker" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Calle Piquillín y El Parral"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:map-marker" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Todas Las Vertientes y Ascochinga"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:map-marker" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Calle Liquidámbar y Pasaje Crespón"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:map-marker" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Barrio Colinas"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:map-marker" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Los Molles (excepto sábados)"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:map-marker" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Barrio La Primavera (excepto sábados)"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:map-marker" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="La Granja Centro"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12}>
        <Paper
            elevation={3}
            sx={{
              p: { xs: 2, sm: 3 },
              borderRadius: 4,
              borderLeft: "8px solid #163e6a",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
            >
              Recomendaciones Generales
            </Typography>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={12} sm={6} display="flex" flexDirection={"column"}>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:clock-outline" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Sacar los residuos sólo en los horarios indicados."
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:recycle" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="No mezclar reciclables con basura domiciliaria."
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:leaf" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Presentar los residuos verdes en manojos ordenados y manejables."
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                </List>
              </Grid>
              <Grid item xs={12} sm={6} display="flex" flexDirection={"column"}>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:alert-circle-outline" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Evitar arrojar residuos en la vía pública o en espacios naturales."
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:weather-rainy" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="En caso de lluvias intensas, los recorridos pueden reprogramarse."
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:trash-can-outline" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Mantener el cesto domiciliario en condiciones."
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                </List>
              </Grid>
            </Grid>
           
          </Paper>
        </Grid>
        <Grid item xs={12}>
        <Paper
            elevation={3}
            sx={{
              p: { xs: 2, sm: 3 },
              borderRadius: 4,
              borderLeft: "8px solid #163e6a",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
            >
              Campaña SRC – Separá, Reciclá, Cuidá
            </Typography>

            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 2 }}
            >
              La Granja Más Limpia
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 2 }}
            >
              La Municipalidad impulsa la campaña SRC – Separá, Reciclá, Cuidá,
              para fomentar la separación de residuos húmedos y secos. Separar
              correctamente reduce la basura y permite reutilizar materiales.
            </Typography>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={12} sm={6} display="flex" flexDirection={"column"}>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontSize: { xs: "1.1rem", sm: "1.2rem" } }}
                >
                  Residuos Secos
                </Typography>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:file-document-outline" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Papel y cartón"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>

                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:bottle-soda-outline" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Plásticos (botellas, tapitas, envases)"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:glass-wine" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Vidrio (botellas y frascos)"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:package-variant" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Latas y metales"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:package-variant" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Telgopor limpio"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:package-variant-closed" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Tetrabrik"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                </List>
                <Typography
                  variant="body1"
                  sx={{ fontSize: "1rem", mt: 2 }}
                >
                  Colocar los residuos secos en bolsas o cajas de cartón
                  identificadas.
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} display="flex" flexDirection={"column"}>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontSize: { xs: "1.1rem", sm: "1.2rem" } }}
                >
                  Residuos Húmedos
                </Typography>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:food" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Restos de comida"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:coffee-outline" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Yerba, café, saquitos de té"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:food-apple" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Cáscaras y carozos de frutas"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:baby-face-outline" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Pañales descartables"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Icon icon="mdi:file-remove-outline" color="#163e6a" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Servilletas y papeles sucios"
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary=""
                      primaryTypographyProps={{
                        fontSize: "1rem",
                      }}
                    />
                  </ListItem>
                </List>
                <Typography
                  variant="body1"
                  sx={{ fontSize: "1rem", mt: 2 }}
                >
                  Si el residuo está sucio o mezclado, es basura; pero limpio y
                  separado es un recurso que puede reutilizarse.
                </Typography>{" "}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12}>
        <Paper
            elevation={3}
            sx={{
              p: { xs: 2, sm: 3 },
              borderRadius: 4,
              borderLeft: "8px solid #163e6a",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
            >
              Recolección Diferenciada de Reciclables
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 2 }}
            >
              Miércoles por la noche: Villa Ani Mi y Martín Fierro
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 2 }}
            >
              Jueves por la noche: Las Vertientes y Ascochinga
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 2 }}
            >
              Sacar los reciclables limpios y secos los días correspondientes a
              cada barrio.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
